import http from "./http";
export default () => ({
  async session(filters) {
    return http
      .index("sessions", filters)
      .then((json) => ({ session: json }))
      .catch(async (e) => ({ session: null, error: await e }));
  },
});
